import axios from "axios";
import {Dispatch} from "redux";
import {IContent, IData} from "src/ScrollyInterface";

import {
	dispatchFunc,
	IFetchDataFailedAction,
	IFetchDataStartAction,
	IGetContentAction,
	INavigationClickedAction,
	INavigationFinishedAction,
	IScrollClickedAction,
	IScrollFinishedAction,
	ISetDataAction,
	ISetMediaLoadedAction,
	ISetScrollDirectionAction
} from "src/store//StoreInterface";
import * as actionTypes from "src/store/actions//actionTypes";

export const getContent = (data: IContent): IGetContentAction => {
	return {
		payload: data,
		type: actionTypes.GET_CONTENT
	};
};

export const fetchDataStart = (): IFetchDataStartAction => {
	return {
		type: actionTypes.FETCH_DATA_START
	};
};

export const setData = (data: IData): ISetDataAction => {
	return {
		type: actionTypes.SET_DATA,
		// tslint:disable-next-line:object-literal-sort-keys
		payload: data
	};
};

export const fetchDataFailed = (): IFetchDataFailedAction => {
	return {
		type: actionTypes.FETCH_DATA_FAILED
	};
};

export const initData = (): dispatchFunc => {
	return (
		dispatch: Dispatch<IFetchDataStartAction | ISetDataAction | IFetchDataFailedAction>
	): void => {
		dispatch(fetchDataStart());
		axios
			.get("https://scrollfilms-puur-groen-gas-default-rtdb.firebaseio.com/data.json")
			.then(response => {
				dispatch(setData(response.data));
			})
			.catch(error => {
				dispatch(fetchDataFailed());
			});
	};
};

export const navigationClicked = (id: number): INavigationClickedAction => {
	return {
		payload: id,
		type: actionTypes.NAVIGATION_CLICKED
	};
};

export const navigationFinished = (): INavigationFinishedAction => {
	return {
		type: actionTypes.NAVIGATION_FINISHED
	};
};

export const setMediaLoaded = (mediaLoaded: boolean): ISetMediaLoadedAction => {
	return {
		payload: mediaLoaded,
		type: actionTypes.SET_MEDIA_LOADED
	};
};

export const setScrollDirection = (
	scrollDirection: "up" | "down"
): ISetScrollDirectionAction => {
	return {
		payload: scrollDirection,
		type: actionTypes.SET_SCROLL_DIRECTION
	};
};

export const scrollClicked = (): IScrollClickedAction => {
	return {
		type: actionTypes.SCROLL_CLICKED
	};
};

export const scrollFinished = (): IScrollFinishedAction => {
	return {
		type: actionTypes.SCROLL_FINISHED
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/data.tsx